import modules from '~/modules'
import type { GaApp } from '~/modules/app'

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()
  const gaApp: GaApp = nuxtApp.$gaApp

  gaApp.installModules<typeof modules>(modules)

  return {
    provide: {
      stores: gaApp.modules.stores,
      repositories: gaApp.modules.repositories,
      services: gaApp.modules.services,
    },
  }
})
